/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NumberCircle08Icon16Light } from './NumberCircle08Icon16Light';
import { NumberCircle08Icon16Regular } from './NumberCircle08Icon16Regular';
import { NumberCircle08Icon16Solid } from './NumberCircle08Icon16Solid';
import { NumberCircle08Icon20Light } from './NumberCircle08Icon20Light';
import { NumberCircle08Icon20Regular } from './NumberCircle08Icon20Regular';
import { NumberCircle08Icon20Solid } from './NumberCircle08Icon20Solid';
import { NumberCircle08Icon24Regular } from './NumberCircle08Icon24Regular';
import { NumberCircle08Icon24Solid } from './NumberCircle08Icon24Solid';
import { NumberCircle08Icon32Regular } from './NumberCircle08Icon32Regular';
import { NumberCircle08Icon64Regular } from './NumberCircle08Icon64Regular';
var sizes = {
    16: {
        light: NumberCircle08Icon16Light,
        regular: NumberCircle08Icon16Regular,
        solid: NumberCircle08Icon16Solid,
    },
    20: {
        light: NumberCircle08Icon20Light,
        regular: NumberCircle08Icon20Regular,
        solid: NumberCircle08Icon20Solid,
    },
    24: {
        regular: NumberCircle08Icon24Regular,
        solid: NumberCircle08Icon24Solid,
    },
    32: {
        regular: NumberCircle08Icon32Regular,
    },
    64: {
        regular: NumberCircle08Icon64Regular,
    },
};
export var NumberCircle08Icon = forwardRef('NumberCircle08Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
